import { InputSwitch, InputSwitchProps } from 'primereact/inputswitch';
import { Control, Controller } from 'react-hook-form';
import classes from './toggle.module.scss';

export type ToggleProps = InputSwitchProps & {
  isRequired?: boolean;
  labelClassName?: string;
  rootClassName?: string;
  inputClassName?: string;
  fieldId: string;
  hint?: string;
  label?: string;
  error?: string;
  name: string;
  control?: Control<any>;
  isDisabled?: boolean;
  onChange?: () => void;
  checked: boolean;
};

export const SimpleToggle = ({ ...props }: ToggleProps) => {

  return (
    <div className={classes.root}>
      <InputSwitch
        disabled={props.isDisabled}
        checked={props.checked}
        onChange={props.onChange}
      />
    </div>
  );
};

export const Toggle = (props: ToggleProps) =>
  !props.control ? (
    <SimpleToggle {...props} />
  ) : (
    <Controller
      render={({ field: { ref, ...field } }) => (
        <SimpleToggle inputRef={ref} {...field} {...props} />
      )}
      name={props.name}
      control={props.control}
    />
  );
